// EventModalLogic.tsx
import { useMemo } from "react";

export const useEventModalStyles = () => {
  const styles = useMemo(
    () => ({
      overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1300, // typical z-index for modals
        padding: "16px", // Add padding to ensure modal doesn't touch screen edges on mobile
      },
      container: {
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
        width: "100%",
        maxWidth: "400px",
        maxHeight: "90vh", // Limit height and enable scrolling for very tall modals
        overflow: "auto",
        animation: "fadeIn 0.2s ease-out",
      },
      header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#3f51b5", // Primary blue color
        color: "#fff",
        padding: "16px",
        borderTopLeftRadius: "8px",
        borderTopRightRadius: "8px",
      },
      closeButton: {
        color: "#fff",
        cursor: "pointer",
        border: "none",
        background: "none",
        fontSize: "24px",
        padding: "4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      content: {
        padding: "16px",
      },
      section: {
        display: "flex",
        alignItems: "flex-start",
        marginBottom: "16px",
      },
      icon: {
        marginRight: "8px",
        marginTop: "0px",
        color: "white",
        padding: "2px",
        borderRadius: "99px",
        background: "#4051b6",
      },
      text: {
        color: "text.primary",
        fontSize: "14px",
        lineHeight: "20px",
      },
      buttonContainer: {
        display: "flex",
        justifyContent: "flex-end",
        gap: "8px",
        marginTop: "24px",
      },
      deleteButton: {
        display: "flex",
        alignItems: "center",
        paddingLeft: "12px",
        paddingRight: "12px",
        paddingTop: "8px",
        paddingBottom: "8px",
        backgroundColor: "error.light",
        color: "error.main",
        borderRadius: "8px",
        textTransform: "none",
        "&:hover": {
          backgroundColor: "error.main",
          color: "#fff",
        },
      },
      editButton: {
        display: "flex",
        alignItems: "center",
        paddingLeft: "12px",
        paddingRight: "12px",
        paddingTop: "8px",
        paddingBottom: "8px",
        backgroundColor: "info.light",
        color: "info.main",
        borderRadius: "8px",
        textTransform: "none",
        "&:hover": {
          backgroundColor: "info.main",
          color: "#fff",
        },
      },
    }),
    []
  );

  return { styles };
};
